import a, { css as i } from "styled-components";
import { Loading as z } from "../../DataDisplay/Loading/Loading.es.js";
const g = a(z).withConfig({
  displayName: "Loading",
  componentId: "sc-6dbgwc-0"
})([""]), x = {
  sm: "ctaSm",
  md: "ctaMd",
  lg: "ctaLg"
}, y = {
  sm: "caption1",
  md: "body2",
  lg: "body1"
}, L = a.button.withConfig({
  displayName: "Button",
  componentId: "sc-6dbgwc-1"
})(["", ""], ({
  theme: t,
  block: o,
  disabled: e,
  size: d,
  variant: n,
  color: r,
  rounded: b,
  order: c = null,
  uppercase: w
}) => {
  var p, h, l;
  const s = v.getSize(d, c), f = (h = t.typography) == null ? void 0 : h[(p = n === "link" ? y : x) == null ? void 0 : p[d]];
  return i(["align-items:center;background-color:var(--color-components-button-", "-", "-bg);border:1px solid var(--color-components-button-", "-", "-border);border-radius:var(--size-components-button-border-radius);color:var(--color-components-button-", "-", "-fg);cursor:pointer;display:flex;font-family:inherit;justify-content:center;", ";text-wrap:nowrap;transition:all 0.2s ease-in-out;width:fit-content;", " text-transform:", ";line-height:normal;", " &:active{transform:scale(0.98);}", " &:disabled{cursor:not-allowed;opacity:0.4;pointer-events:all;}", "{order:", ";}", " ", ""], r, n, r, n, r, n, s, f, w ? "uppercase" : "none", !e && i(["&:hover{background-color:var(--color-components-button-", "-", "-bg-hover);border:1px solid var(--color-components-button-", "-", "-border-hover);color:var(--color-components-button-", "-", "-fg-hover);}"], r, n, r, n, r, n), n === "link" && i(["background-color:transparent;border:none;font-weight:400;gap:2px;height:auto;min-width:fit-content;padding:0;text-decoration:underline;width:fit-content;&:hover{border:none;}"]), (l = g.S) == null ? void 0 : l.Loading, c, !!b && i(["border-radius:calc(", " / 2);"], s.height), !!o && i(["width:100%;"]));
}), B = a(L).withConfig({
  displayName: "IconButton",
  componentId: "sc-6dbgwc-2"
})(["", ""], ({
  size: t
}) => {
  var e;
  const o = v.getIconSize(t);
  return i(["height:", ";min-height:", ";min-width:", ";padding:0;width:", ";", "{height:calc(", " - 10px);max-height:calc(", " - 10px);max-width:calc(", " - 10px);min-height:calc(", " - 10px);min-width:calc(", " - 10px);width:calc(", " - 10px);& > div > div{border-width:2px;}}"], o.height, o.height, o.height, o.height, (e = g.S) == null ? void 0 : e.Loading, o.height, o.height, o.height, o.height, o.height, o.height);
});
var u;
const I = a.a.withConfig({
  displayName: "LinkButton",
  componentId: "sc-6dbgwc-3"
})(["align-items:center;background-color:transparent;border:none;cursor:pointer;display:flex;font-weight:800;gap:var(--size-gap-8);outline:none;padding:0;text-decoration:underline;transition:all 0.2s ease-in-out;", " &:active{transform:scale(0.98);}", " ", "{height:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px;width:16px;& > div > div{border-width:2px;}}"], ({
  size: t,
  color: o
}) => i(["", " ", ""], m.size[t], m.color[o]), ({
  disabled: t
}) => t && i(["cursor:not-allowed;opacity:0.4;pointer-events:all;"]), (u = g.S) == null ? void 0 : u.Loading), C = a.div.withConfig({
  displayName: "ButtonLoading",
  componentId: "sc-6dbgwc-4"
})(["height:3rem;width:3rem;"]), N = a.div.withConfig({
  displayName: "ButtonGroup",
  componentId: "sc-6dbgwc-5"
})(["align-items:center;display:flex;flex-direction:row;flex-wrap:wrap;gap:1.6rem;"]), m = {
  color: {
    default: {
      color: "var(--color-fg-default)",
      "&:hover": {
        color: "var(--color-fg-strong)"
      }
    },
    light: {
      color: "var(--color-fg-weak)",
      "&:hover": {
        color: "var(--color-fg-strong)"
      }
    },
    accent: {
      color: "var(--color-accent-primary-stronger)",
      "&:hover": {
        color: "var(--color-accent-primary-strongest)"
      }
    }
  },
  size: {
    sm: {
      fontSize: "var(--size-12)"
    },
    md: {
      fontSize: "var(--size-14)"
    },
    lg: {
      fontSize: "var(--size-16)"
    }
  }
}, v = {
  getSize: (t, o = null) => {
    var d, n;
    const e = {
      sm: {
        padding1: "0 var(--size-padding-12) 0 var(--size-padding-8)",
        padding0: "0 var(--size-padding-8) 0 var(--size-padding-12)",
        paddingnull: "0 var(--size-padding-12)",
        gap: "var(--size-gap-8)"
      },
      md: {
        padding0: "0 var(--size-padding-24) 0 var(--size-padding-16)",
        padding1: "0 var(--size-padding-16) 0 var(--size-padding-24)",
        paddingnull: "0 var(--size-padding-24)",
        gap: "var(--size-gap-8)"
      },
      lg: {
        padding0: "0 var(--size-padding-32) 0 var(--size-padding-24)",
        padding1: "0 var(--size-padding-24) 0 var(--size-padding-32)",
        paddingnull: "0 var(--size-padding-32)",
        gap: "var(--size-gap-4)"
      }
    };
    return {
      height: `var(--size-components-button-height-${t})`,
      minWidth: `var(--size-components-button-min-width-${t})`,
      padding: (d = e[t]) == null ? void 0 : d[`padding${o}`],
      gap: (n = e[t]) == null ? void 0 : n.gap
    };
  },
  getIconSize: (t) => ({
    height: `var(--size-icon-${t})`,
    minWidth: `var(--size-icon-${t})`
  })
};
export {
  L as Button,
  N as ButtonGroup,
  C as ButtonLoading,
  B as IconButton,
  I as LinkButton,
  g as Loading
};
//# sourceMappingURL=style.es.js.map
